import React, { useEffect, useState } from 'react';
import PageContent from '../../components/layout/PageContent';
import axios from 'axios';
import CustomForm from '../../components/form/CustomForm';
import { useHistory } from 'react-router';
import { Input } from 'antd';

const AddUser = () => {

	const [ fields, setFields ] = useState([]);
	const [ loadingFields, setLoadingFields ] = useState(false);
	const [ pw, setPW ] = useState(undefined);

	const history = useHistory();

	useEffect(() => {
		setLoadingFields(true);
		axios.get(`/api/1.0/user`)
		.then(({ data = {} }) => {
			const { result = [] } = data;
			setFields(result);
		})
		.catch(err => {
			console.error('Fetch User Fields: ', err);
		})
		.finally(() => setLoadingFields(false))
	}, []);

	const handleSubmit = values => {
		return axios.post(`/api/1.0/user`, values)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/user');
			}
		})
		.catch(err => {
			console.error('Create User: ', err);
		})
	}

	const handleCancel = () => {
		history.push('/user')
	}

	const getFields = () => {
		return fields.map(field => {
			if (field.key === 'password') {
				return {
					...field,
					instance: 'custom',
					component: (
						<Input
						type='password'
						onChange={e => {
							if (pw === undefined) {
								setPW(e.currentTarget.value.slice(-1));
							} else {
								setPW(e.currentTarget.value);
							}
						}}
						/>
					),
					value: pw === undefined ? field.value : pw,
					// maskedValue: pw,
				}
			}
			return {
				...field,
			}
		})
	}

	return (
		<PageContent 
			background='#fff'
			subheader={{
				title: 'Системийн хэрэглэгч нэмэх',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={getFields()}
				loading={loadingFields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default AddUser;